export const ContractActionTypes = {
  RETRIEVE_CONTRACTS: "RETRIEVE_CONTRACTS",
  RETRIEVE_CONTRACT_DETAILS: "RETRIEVE_CONTRACT_DETAILS",
  UPDATE_CONTRACT: "UPDATE_CONTRACT",
  RESET_CONTRACT: "RESET_CONTRACT",
  PAYMENT_TERMS: "PAYMENT_TERMS",
  BRAND_DETAILS: "BRAND_DETAILS",
};

export default ContractActionTypes;
